import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';


export interface CollageTemplateNameData {
  name: string;
  descr: string;
}

@Component({
  selector: 'app-collage-template-name',
  templateUrl: './collage-template-name.component.html',
  styleUrls: ['./collage-template-name.component.css']
})
export class CollageTemplateNameComponent implements OnInit {
  name = '';
  descr = '';

  constructor(
    public nameDialog: MatDialogRef<CollageTemplateNameComponent, CollageTemplateNameData>,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
  }

  save() {
    if (this.name === null || this.name === undefined) {
      this.showErrorMessage('Please Fill In Name');
      return;
    } else if (this.descr === null || this.descr === undefined ) {
      this.showErrorMessage('Please Fill In Description');
      return;
    }
    this.nameDialog.close({
      name: this.name,
      descr: this.descr
    });
  }

  cancel() {
    this.nameDialog.close();
  }

  private showErrorMessage(message: string) {
    this.snackBar.open(message, 'Error', {
      duration: 3000,
      verticalPosition: 'top'
    });
  }
}
